import { Pipe, PipeTransform } from '@angular/core';
import { stripHtml } from '@marmon/shared/types/export';

@Pipe({
	name: 'stripHtml',
	standalone: true,
})
export class StripHtmlPipe implements PipeTransform {
	transform(value: string) {
		return stripHtml(value);
	}
}
